<div class="delete-sheet">

  <!-- ÉTAPE 1 : Avertissement + phrase de confirmation -->
  <div *ngIf="step === 'warning'" class="delete-step">
    <div class="delete-step__header delete-step__header--danger">
      <mat-icon>warning</mat-icon>
      <h3>Suppression du compte</h3>
    </div>

    <div class="delete-step__body">
      <p class="delete-step__alert">
        <strong>Attention :</strong> cette action est <strong>irréversible</strong>.
        Toutes vos données seront définitivement supprimées :
      </p>
      <ul class="delete-step__list">
        <li>Votre compte et vos identifiants</li>
        <li>Vos profils socio et adhésions</li>
        <li>Vos pronostics et scores</li>
        <li>Vos votes, suggestions et documents</li>
        <li>Vos abonnements aux notifications</li>
      </ul>

      <p class="delete-step__instruction">
        Pour continuer, tapez exactement la phrase suivante :
      </p>
      <p class="delete-step__phrase">« {{ confirmPhrase }} »</p>

      <mat-form-field appearance="outline" class="delete-step__input">
        <mat-label>Tapez la phrase ci-dessus</mat-label>
        <input matInput [(ngModel)]="typedPhrase" autocomplete="off" spellcheck="false">
      </mat-form-field>
    </div>

    <div class="delete-step__actions">
      <button mat-stroked-button (click)="close()">Annuler</button>
      <button mat-flat-button color="warn" [disabled]="!isPhraseValid" (click)="goToPassword()">
        Continuer
      </button>
    </div>
  </div>

  <!-- ÉTAPE 2 : Mot de passe -->
  <div *ngIf="step === 'password'" class="delete-step">
    <div class="delete-step__header delete-step__header--danger">
      <mat-icon>lock</mat-icon>
      <h3>Confirmez votre identité</h3>
    </div>

    <div class="delete-step__body">
      <p>Entrez votre mot de passe actuel pour confirmer la suppression du compte <strong>{{ data.email }}</strong>.</p>

      <mat-form-field appearance="outline" class="delete-step__input">
        <mat-label>Mot de passe</mat-label>
        <input matInput type="password" [(ngModel)]="password" autocomplete="current-password">
        <mat-error *ngIf="passwordError">Mot de passe incorrect</mat-error>
      </mat-form-field>

      <p *ngIf="passwordError" class="delete-step__error">
        <mat-icon>error</mat-icon> Mot de passe incorrect. Veuillez réessayer.
      </p>
    </div>

    <div class="delete-step__actions">
      <button mat-stroked-button (click)="close()">Annuler</button>
      <button mat-flat-button color="warn" [disabled]="!password" (click)="goToCountdown()">
        Supprimer mon compte
      </button>
    </div>
  </div>

  <!-- ÉTAPE 3 : Countdown -->
  <div *ngIf="step === 'countdown'" class="delete-step">
    <div class="delete-step__header delete-step__header--danger">
      <mat-icon>timer</mat-icon>
      <h3>Dernière chance</h3>
    </div>

    <div class="delete-step__body delete-step__body--center">
      <p>Votre compte sera supprimé dans :</p>
      <div class="delete-step__countdown">{{ countdown }}</div>
      <p class="delete-step__countdown-label">secondes</p>
      <p class="delete-step__cancel-hint">Vous pouvez encore annuler.</p>
    </div>

    <div class="delete-step__actions delete-step__actions--center">
      <button mat-flat-button color="primary" (click)="cancelCountdown()">
        <mat-icon>undo</mat-icon> Annuler la suppression
      </button>
    </div>
  </div>

  <!-- ÉTAPE FINALE : Confirmation -->
  <div *ngIf="step === 'done'" class="delete-step">
    <div class="delete-step__header">
      <mat-icon>check_circle</mat-icon>
      <h3>Compte supprimé</h3>
    </div>
    <div class="delete-step__body delete-step__body--center">
      <p>Votre compte a été supprimé. Vous allez être déconnecté.</p>
    </div>
  </div>

  <!-- ERREUR -->
  <div *ngIf="step === 'error'" class="delete-step">
    <div class="delete-step__header delete-step__header--danger">
      <mat-icon>error_outline</mat-icon>
      <h3>Erreur</h3>
    </div>
    <div class="delete-step__body">
      <p>Une erreur est survenue lors de la suppression. Veuillez réessayer plus tard ou contacter le support à <a href="mailto:contact@sociochaux.fr">contact@sociochaux.fr</a>.</p>
    </div>
    <div class="delete-step__actions">
      <button mat-flat-button (click)="close()">Fermer</button>
    </div>
  </div>

</div>
